import React, { FC } from 'react'

import { IconBiometricAuthenticationProps } from './IconBiometricAuthentication.types'
import * as Styled from './styles/IconBiometricAuthentication.style'

import { nonThemeableRules } from '../../ruleSet'

const IconBiometricAuthentication: FC<IconBiometricAuthenticationProps> = ({
  size = nonThemeableRules.defaultSize as number as IconBiometricAuthenticationProps['size'],
  isResponsive = false,
}: IconBiometricAuthenticationProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M23.805 23.565c0 8.29.925 10.13-5.545 16.577M35.455 11.75a16.645 16.645 0 0 0-27 5.445M40.448 29.85c.042-1.25.04-2.5.02-3.81 0-.785-.023-1.598-.023-2.463a16.41 16.41 0 0 0-2.18-8.192'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M33.088 38.475c1.75-3.97 1.902-7.738 1.835-12.35 0-.75-.023-1.547-.025-2.395 0-6.117-5.055-11.268-11.195-11.203a11.083 11.083 0 0 0-11 11.038c0 1.082 0 2.043.027 2.89 0 .5.015 1.053.018 1.583a4.585 4.585 0 0 1-1.225 3.134c-.298.325-.675.71-1.125 1.158a11.08 11.08 0 0 0-1.123 1.325'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M29.198 31.865c.21-1.702.212-3.53.18-5.66 0-.832-.026-1.692-.026-2.645a5.547 5.547 0 0 0-11.092 0c0 1.035 0 1.978.025 2.808.043 2.774.045 4.155-.313 5.184-.385 1.12-1.5 2.553-3.635 4.673-.43.43-.786.927-1.054 1.472'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M24.98 41a20.17 20.17 0 0 0 3.035-4.72' stroke='#fff' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconBiometricAuthentication
